import { useEffect } from 'react';
import usePrevious from '../../effects/usePrevious';

const useFieldsController = ({ eventType }, setValue) => {
  const prevEventType = usePrevious(eventType);

  useEffect(() => {
    if (prevEventType) {
      /**
       * don't clear initial load
       */
      setValue('game');
      setValue('platform');
      setValue('appVersion');
      setValue('minAppVersion');
      setValue('maxAppVersion');
      setValue('notesLink');
      setValue('responsible');
      setValue('serverVersion');
      setValue('audience');
      setValue('channel');
      setValue('resolutionDate');
      setValue('techTag');
      setValue('classTag');
      setValue('typeTag');
    }
  }, [eventType]);
};

export default useFieldsController;
